import { render, staticRenderFns } from "./TransferProductTitleDetail.vue?vue&type=template&id=c6f2aaca&"
import script from "./TransferProductTitleDetail.vue?vue&type=script&lang=js&"
export * from "./TransferProductTitleDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports